// Footer dropdowns
const footerDropdownButtons = document.querySelectorAll('.dropdown-button');

footerDropdownButtons.forEach(button => {
  button.addEventListener('click', event => {
    if (button.classList.contains('active')) {
      button.classList.remove('active')
      slideUp(button.nextElementSibling, 300);
    } else {
      button.classList.add('active')
      slideDown(button.nextElementSibling, 300);
    }
  });
});

// Footer credits
const creditsButtons = document.querySelectorAll('.js-open-credits');
const creditsCloseButtons = document.querySelectorAll('.site-credits__close');
const credits = document.querySelector('.site-credits');

creditsButtons.forEach(creditsButton => {
  creditsButton.addEventListener('click', event => {
    event.preventDefault();
    credits.setAttribute('aria-hidden', false);

    document.addEventListener('keydown', function(event){
      if (event.key === "Escape") {
        credits.setAttribute('aria-hidden', false);
      }
    });
  });
});

creditsCloseButtons.forEach(creditsCloseButton => {
  creditsCloseButton.addEventListener('click', event => {
    credits.setAttribute('aria-hidden', true);
  });
});